import { HTTPMethod } from 'helpers/method';
import { ENDPOINT } from 'services/configs/endpoint.constant';

import {
  GetDocumentsByProjectParams,
  GetListConnectionParams,
  GetListConnectionResponse,
  GetListDocumentsResponse,
  GetListProjectParams,
  GetListProjectsResponse,
  SyncDocumentBodyRequest,
  SyncDocumentBodyResponse,
  SyncDocumentHistory,
} from './synchronization.type';
import { request } from '../configs/axiosConfig';

export const SynchronizationService = {
  fetchListConnections: async (params: GetListConnectionParams) => {
    return request<GetListConnectionResponse>({
      method: HTTPMethod.GET,
      url: ENDPOINT.GET_ALL_CONNECTIONS,
      params,
    });
  },

  fetchListProjects: async (params: GetListProjectParams) => {
    return request<GetListProjectsResponse>({
      method: HTTPMethod.GET,
      url: ENDPOINT.GET_ALL_PROJECTS_SYNCHRONIZATION(params.connection_id),
      params,
    });
  },

  fetchDocumentsByProject: async (params: GetDocumentsByProjectParams) => {
    return request<GetListDocumentsResponse>({
      method: HTTPMethod.GET,
      url: ENDPOINT.GET_ALL_DOCUMENTS_BY_PROJECT(params.connection_id),
      params,
    });
  },

  syncDocumentRequest: async (connectionId: string, data: SyncDocumentBodyRequest) => {
    return request<SyncDocumentBodyResponse>({
      method: HTTPMethod.POST,
      url: ENDPOINT.CREATE_SYNCHRONIZATION(connectionId),
      data,
      params: { connection_id: connectionId },
    });
  },

  syncDocumentHistories: async (
    params: {
      connection_id?: string;
      site?: string;
    } = {}
  ) => {
    return request<SyncDocumentHistory[]>({
      method: HTTPMethod.GET,
      url: ENDPOINT.SYNCHRONIZE_HISTORY,
      params,
    });
  },

  // Deletes a single synchronization (one synced folder): stops its Azure workflows and removes
  // its sync items, leaving the connection and its other syncs untouched.
  deleteSyncHistory: async (syncId: string) => {
    return request<string>({
      method: HTTPMethod.DELETE,
      url: ENDPOINT.DELETE_SYNCHRONIZATION(syncId),
      responseType: 'text',
    });
  },
};
